document.addEventListener("DOMContentLoaded", async () => {
    const { renderTabs, handleTabQueryParam } = await import ("../components/tab.js");
    const isScrollTop = true;
    renderTabs(".js-tab", isScrollTop, 'tab');
    handleTabQueryParam(".js-tab");

});
